import { env } from '../../env';


export class Setup {

    remoteUrl: string = '';
    showLogs: boolean = false;

    private constructor() {
        this.fetchData();
    }

    private static instance: Setup;
    static getInstance(): Setup {
        if (!this.instance) {
            this.instance = new Setup();
        }
        return this.instance;
    }

    private fetchData() {
        this.remoteUrl = env.REACT_APP_API_URL;
        this.showLogs = false;
    }

}

